module.exports = __webpack_public_path__ + "ov_4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/contact/ov/ov_4.jpg
// module id = 875
// module chunks = 0